import { render, staticRenderFns } from "./TestQuestionAnswerRadioGroup.vue?vue&type=template&id=6f95a19b&"
import script from "./TestQuestionAnswerRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./TestQuestionAnswerRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports